import React from "react";
import img from "../../assets/icons/team_icon-01-01.png";
import book from "../../assets/icons/book_svg-01.png";
import surendar from "../../assets/images/6748 copy.jpg.jpeg";
import dinesh from "../../assets/images/dinesh_sir.jpg";
import RamaChandru from "../../assets/images/Ramachandru Tejavath.jpg.jpeg";
import chiefAdvisor from "../../assets/images/GVR Sir Photo.png";
const HomeTeamMember = () => {
  return (
    <div className="bg-[#EDF3F4] py-20 relative" id="our-team">
      <div className="top-0 absolute">
        <img src={img} alt="" className="w-1/4" />
      </div>
      <div className="bottom-0 right-0 absolute w-1/4">
        <img src={book} alt="" className="" />
      </div>
      <div className="xl:max-w-screen-xl w-11/12 mx-auto flex flex-col justify-center items-center z-10">
        <p className="font-teacher text-base sm:pb-3 pb-0 text-[#005064] font-bold tracking-[4px] uppercase">
          Our Team
        </p>
        <h2
          className="xl:text-5xl sm:text-4xl text-3xl font-semibold text-center py-4 text-[#1a1a1a]"
          style={{
            lineHeight: "1.2em",
          }}
        >
          The Team Members Of The Society
        </h2>

        <div className="md:mt-16 mt-10 grid  xl:gap-8 gap-4 w-full z-[2]">
          <div className="bg-white rounded-2xl max-w-7xl mx-auto p-4 sm:p-6 md:p-8 lg:p-10">
            {/* Row 1 */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
              <div className="lg:col-span-8 order-2 lg:order-1">
                <h3 className="text-2xl md:text-3xl font-extrabold text-[#005064]">
                  Sri Ramachandru Tejavath, IAS (Retd.)
                </h3>

                <h4 className="mt-2 text-base md:text-lg font-bold uppercase tracking-wide text-[#1a1a1a]">
                  Honorary President
                </h4>

                <p className="mt-4 font-semibold text-sm sm:text-base leading-7">
                  He is the Former Special Chief Secretary, Government of Odisha
                  & Former Special Representative of Telangana in New Delhi
                </p>

                <p className="mt-5 text-base leading-7 text-[#1a1a1a]">
                  <span className="font-bold">Sri Ramachandru Tejavath,</span>{" "}
                  is a distinguished former civil servant with an impeccable
                  40-year career spanning the corporate sector, top-tier
                  administrative governance, and public service. Remarkably
                  distinguished as the first IAS officer from the Banjara
                  community in India, his career is marked by spotless
                  integrity, a progressive outlook, and a deep commitment to
                  public welfare, national progress, and the upliftment of
                  marginalized communities.
                </p>

                <p className="mt-5 text-base leading-7 text-[#1a1a1a]">
                  With over 35 years of vast corporate and administrative
                  experience across the State Government of Odisha and the
                  Government of India, he has built an extensive network and an
                  unparalleled record in industrial promotion, defense
                  production, tribal welfare, and major infrastructure
                  development.
                </p>
              </div>

              <div className="lg:col-span-4 order-1 lg:order-2 flex justify-center">
                <img
                  src={RamaChandru}
                  alt="Sri Ramachandru Tejavath"
                  className="w-full max-w-[260px] sm:max-w-[320px] md:max-w-[380px] lg:max-w-full rounded-xl shadow-md object-cover"
                />
              </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 mt-10">
              <div>
                <h5 className="text-xl md:text-2xl font-extrabold text-[#1a1a1a] mb-4">
                  Key Contributions & Strategic Achievements
                </h5>

                <p className="text-base leading-7 text-[#1a1a1a] mb-4">
                  During his tenure as the Special Representative of Telangana
                  in New Delhi (June 2014 – June 2019), he was instrumental in
                  driving critical clearances and structural milestones for the
                  state:
                </p>

                <ul className="list-disc pl-5 md:pl-6 space-y-4 text-base leading-7 text-[#1a1a1a]">
                  <li>
                    Infrastructure & Connectivity: Secured sanctions for
                    upgrading 3,100 km of State Highways to National Highways.
                    He successfully expedited the 151 km
                    Secunderabad-to-Karimnagar railway line and the new 250 km
                    Bhadrachalam Road-to-Kovvuru railway line.
                  </li>

                  <li>
                    Irrigation & Power: Facilitated central forest and
                    environmental clearances for all major irrigation projects
                    in Telangana, alongside the CWC and GoI clearance for the
                    ₹6,800 crore Storm Water Canal of SRSP. He also secured GoI
                    clearance for the Bhadradri Power Project.
                  </li>

                  <li>
                    Healthcare & Institutional Growth: Successfully facilitated
                    the establishment of the AIIMS Centre for Telangana.
                  </li>

                  <li>
                    Tribal Advocacy & Land Rights: Resolved long-standing tribal
                    grievances, heavily focusing on the settlement of Land
                    Pattas for forest lands and 1/70 cases. He remains a
                    prominent authority and advocate for the Constitutional
                    rights and protections of Scheduled Tribes.
                  </li>
                </ul>
              </div>

              <div>
                <h5 className="text-xl md:text-2xl font-extrabold text-[#1a1a1a] mb-4">
                  Areas of Expertise
                </h5>

                <ul className="list-disc pl-5 md:pl-6 space-y-4 text-base leading-7 text-[#1a1a1a]">
                  <li>
                    Industrial Promotion & Defense Production: A core forte in
                    promoting electronics, defense manufacturing, steel,
                    aluminum, and power industries. He pioneered private sector
                    participation in defense production and authorized
                    industrial licensing for SMEs and large Indian industries.
                  </li>

                  <li>
                    International Diplomacy & Relations: Led multiple
                    international delegations regarding defense and security,
                    traveled to 26 countries, and successfully finalized over a
                    dozen Memoranda of Understanding (MoUs) and protocols while
                    interacting with nearly 40 foreign Ambassadors.
                  </li>

                  <li>
                    Crisis Management: Effectively handled severe natural
                    disasters, notably leading relief and administrative efforts
                    during the historic 1999 Super Cyclone in Odisha.
                  </li>

                  <li>
                    Environmental Advocacy: Driven by his personal motto, "Save
                    Mother Earth," he is heavily focused on climate change
                    mitigation, environmental protection, and the conservation
                    of water, soil, and energy.
                  </li>
                </ul>
              </div>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 mt-10">
              <div>
                <h5 className="text-xl md:text-2xl font-extrabold text-[#1a1a1a] mb-4">
                  Career Timeline & Leadership Roles
                </h5>

                <ul className="list-disc pl-5 md:pl-6 space-y-4 text-base leading-7 text-[#1a1a1a]">
                  <li>
                    Special Representative of Telangana (New Delhi): 2014 –
                    2019.
                  </li>

                  <li>
                    Core IAS Career (Odisha Cadre): Retired as Special Chief
                    Secretary. Held prominent positions including Secretary to
                    the Chief Minister of Odisha, Secretary to the Governor of
                    Odisha, Collector & District Magistrate, and Divisional
                    Commissioner overlooking 10 districts.
                  </li>

                  <li>
                    Central Government Postings: Served as Joint Secretary for
                    Ordnance Factories and Missiles Production, and Director of
                    International Cooperation in the Ministry of Defence.
                  </li>

                  <li>
                    Corporate & Board Leadership: Began his career with IBM-CMC
                    (1978–1983). Later served as Director, Chairman, and CMD on
                    various Boards of State PSUs, Defence PSUs, IIT Bhubaneswar,
                    and the Xavier Institute of Management, Bhubaneswar.
                  </li>

                  <li>
                    Management & Associations: National Winner of the Young
                    Managers Award (1982) presented by Sri JRD Tata. Served as a
                    Member of the All India Management Association (AIMA) and
                    President of the Cuttack Management Association for multiple
                    terms.
                  </li>
                </ul>
              </div>

              <div>
                <h5 className="text-xl md:text-2xl font-extrabold text-[#1a1a1a] mb-4">
                  Education & Personal Background
                </h5>

                <h6 className="text-lg font-bold mb-3">Academic Credentials</h6>

                <ul className="list-disc pl-5 md:pl-6 space-y-4 text-base text-[#1a1a1a]  leading-7">
                  <li>
                    Post-Graduate Diploma in Public Administration – Syracuse
                    University, Maxwell School, NY, USA.
                  </li>

                  <li>
                    Post Graduate Degree in Management – Indian Institute of
                    Management (IIM), Ahmedabad.
                  </li>

                  <li>
                    B.E. in Electronics and Communication Engineering – Osmania
                    University, Hyderabad.
                  </li>
                </ul>

                <h5 className="text-xl md:text-2xl font-extrabold mt-8 mb-4">
                  Personal & Demographics
                </h5>

                <p className="text-base leading-7 text-[#1a1a1a]">
                  Born on September 9, 1953, in Collector Thanda, Warangal
                  District, Sri Ramachandru Tejavath is multi-lingual, speaking
                  eloquently in Telugu, Lambadi, English, Hindi, and Odia. He is
                  married to Bhagyalakshmi (Engineer). They have two sons, Varun
                  Raj (Investment Banker, Singapore) and Prithvi Raj (Startup
                  Entrepreneur, Bangalore), both of whom are alumni of IIT and
                  IIM Ahmedabad.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white grid grid-cols-12 lg:gap-8 gap-4 rounded-xl md:p-8 p-4">
            <div className="lg:col-span-4 col-span-12 flex flex-col justify-center">
              <img
                src={surendar}
                alt="Mr. Indula Surendar Reddy"
                className="rounded-xl "
              />
            </div>
            <div className="lg:col-span-8 col-span-12 flex flex-col justify-center">
              <h3 className="text-xl font-extrabold pt-2 text-[#005064]">
                Mr. Indula Surendar Reddy
              </h3>
              <h4 className="pt-1.5 font-bold md:text-lg pb-3 text-base tracking-wider uppercase text-[#1a1a1a]">
                President
              </h4>
              <p className="text-base text-[#1a1a1a]  sm:py-5 py-3">
                <span className="font-bold">Mr. Indula Surendar Reddy,</span>{" "}
                basically a graduate in sciences, completed post graduate
                diploma in business administration from ICFAI and a masters
                holder in business administration. He is an young and dynamic
                enterpreneur with a proven successful track record in managing
                group of industries.
              </p>
              <p className="text-base text-[#1a1a1a]">
                He is one of the promoters and managing partner for many units
                related to mining. Mr. Indula Surendar Reddy is the managing
                director of lakshmi stone crushing Co.Pvt.Ltd. He is a man with
                great vision in the of business administration, business
                operations and team management.
              </p>
              <p className="text-base text-[#1a1a1a]  sm:pt-5 pt-3 pb-1">
                With a strong desire and ambition to start educational
                institutions with international standards to shape the students
                as global citizens, he has founded{" "}
                <span className="font-bold">
                  Sri Lakshmi Narasimha Educational Society
                </span>{" "}
                and joined his hands together with top class administrators,
                academicians in educational field.
              </p>
            </div>
          </div>
          <div className="bg-white grid grid-cols-12 lg:gap-8 gap-4 rounded-xl md:p-8 p-4">
            <div className="lg:col-span-8 col-span-12 lg:order-1 order-2">
              <h3 className="text-xl font-extrabold pt-2 text-[#005064]">
                Mr. Endula Dinesh Reddy
              </h3>
              <h4 className="pt-1.5 font-bold md:text-lg pb-3 text-base  tracking-wider  uppercase text-[#1a1a1a]">
                GENERAL SECRETARY
              </h4>
              <p className="text-base text-[#1a1a1a]  sm:py-5 py-3">
                <span className="font-bold">Mr. Endula Dinesh Reddy,</span> is a
                Civil Engineering graduate from Muffakham Jah College of
                Engineering & Technology and holds a Master's Degree in
                Construction Management from Bradley University, USA.
              </p>
              <p className="text-base text-[#1a1a1a]">
                He began his entrepreneurial journey in 2007 with railway
                infrastructure contracts in Maharashtra before pioneering the
                production of manufactured sand as a sustainable alternative to
                river sand. Through strategic expansion, he grew the business
                from a single unit to six manufacturing plants and currently
                oversees enterprises with a combined turnover exceeding 2100
                Crores.
              </p>
              <p className="text-base text-[#1a1a1a]  sm:py-5 py-3">
                As General Secretary of{" "}
                <span className="font-bold">
                  Sri Lakshmi Narasimha Educational Society
                </span>{" "}
                , he is committed to building an institution that combines
                academic excellence with financial literacy, healthy nutrition,
                mental well-being, physical fitness, and strong communication
                skills to prepare students for lifelong success.
              </p>
              <p className="text-base text-[#1a1a1a]  ">
                He has a wonderful vision and leadership qualities. His social
                contacts with number of intellectuals and educationalists will
                be an asset to the society in the establishment of world class
                educational institutions at present and in future.
              </p>
            </div>
            <div className="lg:col-span-4 col-span-12 flex flex-col justify-center lg:order-2 order-1">
              <img
                src={dinesh}
                alt="Mr. Indula Surendar Reddy"
                className="rounded-xl "
              />
            </div>
          </div>
          <div className="grid xl:grid-cols-2 xl:gap-8 gap-4">
              <div className="bg-white rounded-xl md:p-8 p-4">
              {/* Name + Image */}
              <div className="grid grid-cols-12 gap-6 items-center mb-4">
                <div className="lg:col-span-6 col-span-12">
                  <h3 className="text-xl font-extrabold text-[#005064]">
                    Mr. G. Venkata Ramana Rao
                  </h3>

                  <h4 className="pt-1.5 font-bold md:text-lg text-base tracking-wider uppercase text-[#1a1a1a]">
                    Chief Advisor <br/> 
                    <span className='text-sm'>School Operations</span>
                  </h4>
                </div>

                <div className="lg:col-span-6 col-span-12 flex md:justify-end justify-center">
                  <img
                    src={chiefAdvisor}
                    alt="Mr. G. Venkata Ramana Rao"
                    className="w-52 aspect-[3/4] object-cover rounded-xl"
                  />
                </div>
              </div>

              <p className="text-base text-[#1a1a1a] sm:py-5 py-3">
                <span className="font-bold">Mr. G. Venkata Ramana Rao</span>,
                serves as the Chief Advisor of{" "}
                <span className="font-bold">
                  Sri Lakshmi Narasimha Educational Society
                </span>
                , bringing with him extensive experience and visionary
                leadership in the field of school education and institutional
                development.
              </p>

              <p className="text-base text-[#1a1a1a]">
                A highly respected educational administrator with over two
                decades of proven success, he has played a pivotal role in the
                establishment, development, and management of several
                high-performing K-12 institutions, including both CBSE and State
                Board schools.
              </p>

              <p className="text-base text-[#1a1a1a] sm:py-5 py-3">
                His expertise spans across academic planning, school operations,
                infrastructure development, faculty management, strategic
                leadership, and stakeholder coordination. With a strong focus on
                educational excellence and student success, he has consistently
                contributed to building institutions known for discipline,
                innovation, and academic performance.
              </p>

              <p className="text-base text-[#1a1a1a]">
                As Chief Advisor, he provides strategic guidance and valuable
                insights to the Society, helping shape its vision of delivering
                holistic, future-focused, and value-based education.
              </p>
            </div>
            <div className="bg-white rounded-xl md:p-8 p-4">
              <h3 className="text-xl font-extrabold pt-2 text-[#005064]">
                Dr. A. Raja Reddy
              </h3>
              <h4 className="pt-1.5 font-bold md:text-lg pb-3 text-base  tracking-wider lg: uppercase text-[#1a1a1a]">
                EXECUTIVE COMMITTE MEMBER
              </h4>
              <p className="text-base text-[#1a1a1a]  sm:py-5 py-3">
                <span className="font-bold">Dr. A. Raja Reddy</span>, an
                accomplished academician and distinguished educationist, serves
                as the Executive Committee Member of{" "}
                <span className="font-bold">
                  Sri Lakshmi Narasimha Educational Society
                </span>{" "}
                . With an illustrious academic career spanning nearly four
                decades, he brings exceptional expertise, academic leadership,
                and a commitment to educational excellencе.
              </p>
              <p className="text-base text-[#1a1a1a]">
                Currently serving as the Dean, School of Agricultural Sciences
                at Malla Reddy University, Dr. Raja Reddy holds a Ph.D. from
                Osmania University and has been actively engaged in teaching,
                research, curriculum development, and academic administration
                since 1985.
              </p>
              <p className="text-base text-[#1a1a1a] sm:py-5 py-3">
                Over the course of his career, he has held several prestigious
                positions, including Chairman of the Board of Studies, where he
                played a significant role in curriculum design and academic
                policy development. As a Research Head and academic mentor, he
                has contributed extensively to educational advancement through
                the publication of numerous research papers and scholarly
                articles.
              </p>
              <p className="text-base text-[#1a1a1a]">
                His vast experience, visionary approach, and strong academic
                foundation significantly strengthen the Society's mission to
                deliver quality education and foster academic excellence among
                students.
              </p>
            </div>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTeamMember;
